export default class LandmanPayInfo {
    lmNo: number;
    payUnit: string;
    payRate: number;
    chgDate: Date;
    mgrNo: number;
    prevUnit?: string;
    prevRate?: number;
    tsdUser: string;
    effDate: Date;
}


// WEBPACK FOOTER //
// ./src/models/personnel/LandmanPayInfo.ts